export default "__VITE_ASSET__CeLRIXr2__"